class StarterKitMcube {
	constructor() {
		clickOrTouch = document.documentElement.classList.contains('no-touchevents') ? 'click' : 'touchstart';
		this.madeByMcube();
		this.mcubeDebug();
		mobileCheck = new MobileCheck();
		new ResizeEvents();
		new EventModal();
		new AppearOnScroll();
		pageTransition = new CustomPageTransition();
		new BasePageTransition();
		new Forms();
		new Parallax();
		new TextAppear();
	}

	consoleLog($message, $bg, $color, link) {
		console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;', link);
	}

	madeByMcube() {
		this.consoleLog('Fabriqué à Lyon par Mcube', '#fa2165', '#ffffff', 'www.mcube.fr');
	}

	mcubeDebug() {
		devMode = localStorage.getItem('devMode');
		if (devMode === 'true') {
			document.body.classList.add('debug-mode');
		}
	}
}
